import { render, staticRenderFns } from "./EventGroups.vue?vue&type=template&id=043f4ace"
import script from "./EventGroups.vue?vue&type=script&lang=js"
export * from "./EventGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports